import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Input } from '../ui/input';
import CountrySelector from './CountrySelector';

const BillingSection = ({ data, onChange, errors }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div className="bg-white rounded-xl overflow-hidden border border-gray-200">
      {/* Header - Collapsible */}
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-5 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors"
        data-testid="billing-toggle"
      >
        <div>
          <h3 className="font-semibold text-black text-left">Billing Information</h3>
          <p className="text-xs text-gray-400 text-left">Optional - for invoice purposes</p>
        </div>
        {isExpanded ? (
          <ChevronUp className="h-5 w-5 text-gray-400" />
        ) : (
          <ChevronDown className="h-5 w-5 text-gray-400" />
        )}
      </button>

      {/* Content */}
      {isExpanded && (
        <div className="px-5 pb-5 pt-2 border-t border-gray-100 space-y-4">
          {/* Company / Name */}
          <div className="space-y-1.5">
            <label className="text-xs font-medium text-gray-600">
              Company / Full Name
            </label>
            <Input
              type="text"
              value={data.billingName || ''}
              onChange={(e) => handleChange('billingName', e.target.value)}
              placeholder="Company name or your full name"
              className="h-11 text-black placeholder:text-gray-400"
              data-testid="billing-name"
            />
          </div>

          {/* Tax Number */}
          <div className="space-y-1.5">
            <label className="text-xs font-medium text-gray-600">
              Tax Number / VAT ID
            </label>
            <Input
              type="text"
              value={data.taxNumber || ''}
              onChange={(e) => handleChange('taxNumber', e.target.value)}
              placeholder="e.g., TR1234567890"
              className="h-11 text-black placeholder:text-gray-400"
              data-testid="billing-tax"
            />
          </div>

          {/* Address */}
          <div className="space-y-1.5">
            <label className="text-xs font-medium text-gray-600">
              Billing Address
            </label>
            <Input
              type="text"
              value={data.billingAddress || ''}
              onChange={(e) => handleChange('billingAddress', e.target.value)}
              placeholder="Street address, city, postal code"
              className="h-11 text-black placeholder:text-gray-400"
              data-testid="billing-address"
            />
          </div>

          {/* Country */}
          <CountrySelector
            value={data.billingCountry || ''}
            onChange={(code) => handleChange('billingCountry', code)}
            label="Country"
            placeholder="Select billing country"
          />
        </div>
      )}
    </div>
  );
};

export default BillingSection;
